import React from 'react';
import { Trash } from 'react-bootstrap-icons';

import { useTranslation } from '../../../common/hooks/useTranslation';
import ConfirmationButton from '../../../app/components/ConfirmationButton';

interface DeleteButtonProps {
  itemId: string;
  onDelete: (itemId: string) => Promise<void> | void;
}

export const DeleteButton: React.FC<DeleteButtonProps> = ({
  itemId,
  onDelete,
}) => {
  const { t, tk } = useTranslation('clientLng');

  return (
    <span onClick={event => event.stopPropagation()} role="presentation">
      <ConfirmationButton
        variant="outline-danger"
        className="btn-sm"
        tooltip={t(tk.clientGroup.removeFromGroup)}
        confirmation={t(tk.clientGroup.removeFromGroupConfirm)}
        onOK={() => onDelete(itemId)}
      >
        <Trash />
      </ConfirmationButton>
    </span>
  );
};
